import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const savedToken = typeof localStorage !== "undefined" ? localStorage.getItem("mat_token") : null;
if (savedToken) api.defaults.headers.common.Authorization = `Bearer ${savedToken}`;

// Fall back to the site-gate session token when no admin token is set
api.interceptors.request.use((config) => {
  const site = sessionStorage.getItem("meterox_site_token");
  if (!api.defaults.headers.common.Authorization && site && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${site}`;
  }
  return config;
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem("mat_token", token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem("mat_token");
  }
};

export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);

export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getBrands = (subcategory) =>
  api.get("/brands", { params: { subcategory } }).then((r) => r.data);
export const getProducts = (subcategory, brand) =>
  api.get("/products", { params: { subcategory, brand } }).then((r) => r.data);
export const getProductsByCategory = (category) =>
  api.get("/products", { params: { category } }).then((r) => r.data);
export const getAllProducts = () => api.get("/products").then((r) => r.data);
export const getSimilar = (targetId, brand, bId) =>
  api.get("/similar", { params: { target_id: targetId, brand, ...(bId ? { b_id: bId } : {}) } }).then((r) => r.data);
export const getSimilarList = (targetId, brand) =>
  api.get("/similar-list", { params: { target_id: targetId, brand } }).then((r) => r.data);
export const createProduct = (payload) => api.post("/products", payload).then((r) => r.data);
export const updateProduct = (id, payload) => api.put(`/products/${id}`, payload).then((r) => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);
export const getLeads = () => api.get("/leads").then((r) => r.data);
export const getContacts = () => api.get("/contacts").then((r) => r.data);
export const analyzeSubstrate = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/analyze-substrate", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const translateText = (text, lang) =>
  api.post("/translate", { text, lang }).then((r) => r.data.text);
export const datasheetUrl = (id) => `${API}/products/${id}/datasheet`;
export const uploadDatasheet = (id, file) => {
  const f = new FormData();
  f.append("file", file);
  return api.post(`/products/${id}/datasheet`, f, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const extractDatasheet = (file, subcategory) => {
  const form = new FormData();
  form.append("file", file);
  if (subcategory) form.append("subcategory", subcategory);
  return api
    .post("/extract", form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};
